const currencyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function formatCurrency(value?: number | null): string {
    return value === undefined || value === null ? '' : currencyFormatter.format(value);
}

export function formatCompactNumber(value?: number | null): string {
    return new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 }).format(value || 0);
}

// Valor de campo numérico (input, select) para o request: vazio ou inválido vira undefined
export function parseNumberInput(value: unknown): number | undefined {
    if (value === undefined || value === null || String(value).trim() === '') return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
